import {
    fetchQuery
} from 'Util/Request';

import { EVENT_TYPES } from '../component/MatomoTagManger/MatomoTagManager.events';
import MtmPurchase from '../query/MtmPurchase.query';
import { pushEvent } from '../store/Matomo/Matomo.action';

const mapDispatchToProps = (args, callback) => {
    const [dispatch] = args;

    return {
        ...callback(...args),
        pushEvent: (event, data) => dispatch(pushEvent(event, data))
    };
};

const getOrderData = (orderID, pushEvent) => {
    const query = MtmPurchase.getMTMPurchase(orderID);
    fetchQuery(query).then((data) => {
        const orderData = { ...data, orderID };
        pushEvent(EVENT_TYPES.PURCHASE, orderData);
        pushEvent(EVENT_TYPES.ORDER_UPDATE, orderData);
    });
};

export const containerProps = (args, callback, instance) => {
    const {
        pushEvent
    } = instance.props;

    return {
        pushEvent,
        ...callback.apply(instance, args)
    };
};

const componentDidUpdate = (args, callback, instance) => {
    const [prevProps] = args;
    const { checkoutStep, pushEvent, orderID } = instance.props;
    const { orderID: prevOrderID } = prevProps;
    const { isSuccess } = instance.stepMap[checkoutStep];
    if (isSuccess && orderID !== prevOrderID) {
        getOrderData(orderID, pushEvent);
    }

    return callback.apply(instance, args);
};

export default {
    'Route/Checkout/Component': {
        'member-function': {
            componentDidUpdate
        }
    },
    'Route/Checkout/Container': {
        'member-function': {
            containerProps
        }
    },
    'Route/Checkout/Container/mapDispatchToProps': {
        function: mapDispatchToProps
    }
};
